// extracted by mini-css-extract-plugin
export var colorSquare = "_te-0";
export var danger = "_te-5";
export var lightPink = "_te-8";
export var neutralBlue = "_te-7";
export var neutralYellow = "_te-6";
export var normal = "_te-1";
export var primary = "_te-2";
export var primaryLight = "_te-3";
export var solidBlack = "_te-g";
export var solidGreen = "_te-b";
export var solidLightBlue = "_te-d";
export var solidNavy = "_te-c";
export var solidOrange = "_te-f";
export var solidPink = "_te-e";
export var solidRed = "_te-9";
export var solidYellow = "_te-a";
export var success = "_te-4";